/* ===========================
   FOCINHO FELIZ — THEME JS
   =========================== */

// Sticky nav scroll effect
(function () {
  const nav = document.getElementById('site-header');
  if (!nav) return;
  const onScroll = () => {
    if (window.scrollY > 12) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// Intersection Observer — reveal sections on scroll
(function () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in-view');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.observe').forEach(el => io.observe(el));
})();
